import { render } from "./BudgetDeliveryCreate.vue?vue&type=template&id=3628b3f0&scoped=true"
import script from "./BudgetDeliveryCreate.vue?vue&type=script&lang=js"
export * from "./BudgetDeliveryCreate.vue?vue&type=script&lang=js"

import "./BudgetDeliveryCreate.vue?vue&type=style&index=0&id=3628b3f0&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3628b3f0"]])

export default __exports__